const apiBase = '/api/v1/venstar/thermostat';

export enum Actions {
  GET_VENSTAR_THERMOSTAT_BY_ID_LOADING = '@venstarThermostat/GET_VENSTAR_THERMOSTAT_BY_ID_LOADING',
  GET_VENSTAR_THERMOSTAT_BY_ID_SUCCESS = '@venstarThermostat/GET_VENSTAR_THERMOSTAT_BY_ID_SUCCESS',
  GET_VENSTAR_THERMOSTAT_BY_ID_ERROR = '@venstarThermostat/GET_VENSTAR_THERMOSTAT_BY_ID_ERROR',
}

export const getThermostatById = (id: number | string) => ({
  type: 'API_GET',
  path: `${apiBase}/${id}`,
  loading: {
    type: Actions.GET_VENSTAR_THERMOSTAT_BY_ID_LOADING,
    id,
  },
  success: {
    type: Actions.GET_VENSTAR_THERMOSTAT_BY_ID_SUCCESS,
    id,
  },
  error: {
    type: Actions.GET_VENSTAR_THERMOSTAT_BY_ID_ERROR,
    id,
  },
});
